export const icons = {
  'angle-down': 'la la-angle-down',
  'angle-left': 'la la-angle-left',
  'angle-right': 'la la-angle-right',
  'angle-up': 'la la-angle-up',
  'angles-up-down': 'la la-angles-up-down',
  'arrow-down': 'la la-arrow-down',
  'arrow-left': 'la la-arrow-left',
  'arrow-right': 'la la-arrow-right',
  'arrow-up': 'la la-arrow-up',
  'barcode': 'la la-barcode',
  'bars': 'la la-bars',
  'building': 'la la-building',
  'calendar': 'flaticon-calendar',
  'calendar-2': 'flaticon-calendar-2',
  'car': 'la la-car',
  'catering': 'la la-cutlery',
  'certificate': 'la la-certificate',
  'check': 'la la-check',
  'clock': 'la la-clock-o',
  'close': 'la la-close',
  'company': 'la la-building',
  'compress': 'la la-compress',
  'cross': 'la la-times',
  'desktop': 'la la-desktop',
  'diagram': 'flaticon-diagram',
  'download': 'la la-download',
  'external-link': 'la la-external-link',
  'eye': 'la la-eye',
  'expand': 'la la-expand',
  'file-pdf': 'fa fa-file-pdf-o',
  'flag': 'la la-flag-o',
  'fullscreen': 'la la-arrows-alt',
  'gear': 'la la-gear',
  'hand-out': 'la la-hand-o-right',
  'import': 'la la-cloud-upload',
  'line-graph': 'flaticon-line-graph',
  'lock': 'la la-lock',
  'notes': 'flaticon-notes',
  'map': 'flaticon-map-location',
  'pencil': 'la la-pencil',
  'plus': 'la la-plus',
  'print': 'la la-print',
  'registrations': 'la la-th-list',
  'search': 'la la-search',
  'spinner': 'la la-spinner',
  'sticky-note': 'la la-sticky-note',
  'tag': 'la la-tag',
  'trash': 'la la-trash',
  'truck': 'la la-truck',
  'undo': 'la la-undo',
  'user': 'la la-user',
  'users': 'la la-users',
  'walkie': 'icon-walkie',
  'warning': 'la la-warning',
};
